//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "StoreForm",
  props: ["value"],
  components: {},
  mounted: async function () {
    this.storedData = this.value;

    let store_levels_response = await BackendServices.getStoreHierarchyLevels();
    this.storeHierarchyLevels = store_levels_response.data;

    let store_elements_response =
      await BackendServices.getStoreHierarchyLevelElements(
        this.storeHierarchyLevels[0].id,
        null
      );
    this.storeHierarchyLevelElements.push(
      store_elements_response.data.filter((e) => e.name != "Sem Categorização")
    );
    this.storedStoreHierarchyLevelElements = [
      ...this.storeHierarchyLevelElements,
    ];

    let geo_levels_response =
      await BackendServices.getGeographyHierarchyLevels();
    this.geoHierarchyLevels = geo_levels_response.data;

    let geo_elements_response =
      await BackendServices.getGeographyHierarchyLevelElements(
        this.geoHierarchyLevels[0].id,
        null
      );
    this.geoHierarchyLevelElements.push(
      geo_elements_response.data.filter((e) => e.name != "Sem Categorização")
    );
    this.storedGeoHierarchyLevelElements = [...this.geoHierarchyLevelElements];

    let raw_stores_response = await BackendServices.getRawStores();
    this.storesList = raw_stores_response.data.filter(
      (e) => e.id != this.value.store_id && e.ready && e.name != null
    );
    this.storedStoresList = [...this.storesList];

    this.current_store = this.value.store_id;

    this.validateData();
  },
  updated: function () {
    this.$nextTick(function () {
      this.validateData();
    });
  },
  data: () => ({
    type: null,
    validForm: null,
    parentStore: {
      hierarchy: [
        { name: null, level: { name: "Retalhista" } },
        { name: null, level: { name: "Insignia" } },
        { name: null, level: { name: "Cadeia" } },
      ],
    },
    parentID: null,
    storesList: [],
    storedStoresList: [],
    lastStoreSelectedHierarchyElement: [],
    storeHierarchyLevels: [],
    storeHierarchyLevelElements: [],
    storedStoreHierarchyLevelElements: [],
    lastGeoSelectedHierarchyElement: [],
    geoHierarchyLevels: [],
    geoHierarchyLevelElements: [],
    storedGeoHierarchyLevelElements: [],
    storedData: null,
    current_store: null,
  }),
  methods: {
    required,
    noValidation,
    getStoreHierarchyList(index, level, parentId) {
      if (level === undefined) {
        let exportObj = { ...this.value };
        exportObj.least_hierarchy_level_id =
          this.lastStoreSelectedHierarchyElement[index - 1];
        exportObj.type = "store";
        this.$emit("value", exportObj);
      }
      if (level) {
        BackendServices.getStoreHierarchyLevelElements(level.id, parentId).then(
          ({ data }) => {
            this.lastStoreSelectedHierarchyElement.splice(index);
            this.storeHierarchyLevelElements.splice(index);
            this.storeHierarchyLevelElements.push(data);
            this.storedStoreHierarchyLevelElements.splice(index);
            this.storedStoreHierarchyLevelElements.push(data);
          }
        );
      }
    },
    getGeoHierarchyList(index, level, parentId) {
      if (level === undefined) {
        let exportObj = { ...this.value };
        exportObj.least_geo_level_id =
          this.lastGeoSelectedHierarchyElement[index - 1];
        exportObj.type = "store";
        this.$emit("value", exportObj);
      }
      if (level) {
        BackendServices.getGeographyHierarchyLevelElements(
          level.id,
          parentId
        ).then(({ data }) => {
          this.lastGeoSelectedHierarchyElement.splice(index);
          this.geoHierarchyLevelElements.splice(index);
          this.geoHierarchyLevelElements.push(data);
          this.storedGeoHierarchyLevelElements.splice(index);
          this.storedGeoHierarchyLevelElements.push(data);
        });
      }
    },
    hierarchyValidation: function (index) {
      if (!index) {
        return this.required("Campo obrigatório");
      } else {
        return this.noValidation();
      }
    },
    filterFnByName(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.storesList = this.storedStoresList.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterFnByCode(val, update) {
      update((data = this) => {
        const needle = val;
        data.storesList = data.storedStoresList.filter((v) =>
          v.code.includes(needle)
        );
      });
    },
    setParentStore: async function (storeId) {
      //changes value to: {store_id: parent_id, store_code: child_code, name: child_name}
      let exportObj = {
        store_id: storeId,
        code: this.storedData.store_code,
        name: this.storedData.store_name,
        type: "store",
      };
      let response_hierarchy = await BackendServices.getStoreHierarchy(storeId);
      this.parentStore.hierarchy = response_hierarchy.data;
      this.$emit("value", exportObj);
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    reCreateStoredValue: function () {
      for (let key in this.storedData) {
        this.value[key] = this.storedData[key];
      }
    },
  },
  watch: {
    value: {
      handler: function () {
        if (
          this.value.store_id != this.storedData.store_id &&
          (this.value.type === null || this.value.type === undefined)
        ) {
          this.storedData = this.value;

          this.lastGeoSelectedHierarchyElement = [];
          if (this.geoHierarchyLevelElements.length > 1) {
            this.geoHierarchyLevelElements.splice(1);
          }
          if (this.storedGeoHierarchyLevelElements.length > 1) {
            this.storedGeoHierarchyLevelElements.splice(1);
          }
          this.lastStoreSelectedHierarchyElement = [];
          if (this.storeHierarchyLevelElements.length > 1) {
            this.storeHierarchyLevelElements.splice(1);
          }
          if (this.storedStoreHierarchyLevelElements.length > 1) {
            this.storedStoreHierarchyLevelElements.splice(1);
          }

          this.value.type = null;

          this.parentStore = {
            hierarchy: [
              { name: null, level: { name: "Retalhista" } },
              { name: null, level: { name: "Insignia" } },
              { name: null, level: { name: "Cadeia" } },
            ],
          };
          this.parentID = null;
        }
      },
    },
    type: {
      handler: function () {
        if (this.type === "existing") {
          this.reCreateStoredValue();

          this.lastGeoSelectedHierarchyElement = [];
          if (this.geoHierarchyLevelElements.length > 1) {
            this.geoHierarchyLevelElements.splice(1);
          }
          if (this.storedGeoHierarchyLevelElements.length > 1) {
            this.storedGeoHierarchyLevelElements.splice(1);
          }

          this.lastStoreSelectedHierarchyElement = [];
          if (this.storeHierarchyLevelElements.length > 1) {
            this.storeHierarchyLevelElements.splice(1);
          }
          if (this.storedStoreHierarchyLevelElements.length > 1) {
            this.storedStoreHierarchyLevelElements.splice(1);
          }
        }

        if (this.type === "new") {
          this.reCreateStoredValue();

          this.parentStore = {
            hierarchy: [
              { name: null, level: { name: "Retalhista" } },
              { name: null, level: { name: "Insignia" } },
              { name: null, level: { name: "Cadeia" } },
            ],
          };
          this.parentID = null;
        }
        if (this.type) {
          this.validateData();
        } else {
          this.$emit("form-invalid", false);
        }
        this.$emit("validation-type", this.type);
      },
    },
  },
};
